import { Link, useRouterState } from '@tanstack/react-router'
import { ArrowLeft, Rocket } from 'lucide-react'
import { Page } from '@/components/page-header'
import { Button } from '@/components/ui/button'
import { APP_NAV } from '@/features/shell/nav'

export function ComingSoonPage() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const item = APP_NAV.flatMap((s) => s.items).find((i) => i.to === pathname)
  const Icon = item?.icon ?? Rocket
  return (
    <Page>
      <div className="relative mx-auto mt-6 max-w-2xl overflow-hidden rounded-2xl border bg-card px-6 py-16 text-center shadow-sm sm:px-12">
        <div className="pointer-events-none absolute -top-24 left-1/2 size-72 -translate-x-1/2 rounded-full bg-brand-gradient opacity-[0.12] blur-3xl" aria-hidden />
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] [mask-image:radial-gradient(ellipse_at_top,black_20%,transparent_70%)] bg-[size:28px_28px] opacity-50" aria-hidden />
        <div className="relative">
          <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-brand-gradient text-white shadow-glow">
            <Icon className="size-6" strokeWidth={1.75} />
          </div>
          <p className="mt-6 text-xs font-semibold tracking-[0.12em] text-primary uppercase">Coming in a later phase</p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight">{item?.label ?? 'This page'} is on the way</h1>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
            We’re building {item?.label.toLowerCase() ?? 'this feature'} right now. Your organization, locations and team are ready, so everything will slot in as soon as it ships.
          </p>
          <div className="mt-6 flex justify-center gap-2">
            <Button variant="outline" asChild>
              <Link to="/">
                <ArrowLeft /> Back to dashboard
              </Link>
            </Button>
            <Button asChild>
              <Link to="/locations">Set up locations</Link>
            </Button>
          </div>
        </div>
      </div>
    </Page>
  )
}
